import React from 'react';
import classNames from 'classnames';
import style from './inputWithValidation.module.scss';
import { ValidationErrors } from 'acscp/api/models/errorDetails';
import { ErrorsDisplay } from 'acscp/components/common/errorsDisplay';

interface InputWithValidationProps extends React.InputHTMLAttributes<HTMLInputElement> {
    validationErrors: ValidationErrors | undefined;
    name: string;
    inputContainerClassNames?: string[];
    errorMessagesClassName?: string;
}

const InputWithValidation: React.SFC<InputWithValidationProps> =
    ({validationErrors = {}, name, inputContainerClassNames = [], errorMessagesClassName, children, ...rest }) => {

    const errors = validationErrors[name] || [];
    const errorMessages = errors.map(err => err.message);

    return (
        <div className={classNames(style.inputContainer, inputContainerClassNames)}>
            {React.Children.count(children) === 0
                ? <input {...rest} formNoValidate={true} name={name} />
                : children}
            <ErrorsDisplay errors={errorMessages} showUpArrow={true} className={errorMessagesClassName} />
        </div>
    );
};

export { InputWithValidation };
export type { InputWithValidationProps };
